<template>
	<footer class="site-footer">
		<div class="decouvrerBlock">
			<div class="decouvreTitle">
				<t tag="footer.discover.link"/>
			</div>

		</div>
		<div class="site-footer__container">
			<div class="row">
				<div class="col-md-4 col-sm-4 col-8 site-footer__left">
					<div class="site-logo">
						<router-link to="/" class="site-logo__link"><img src="@/assets/img/logo.png" class="site-logo_footer__1" alt="LNL"></router-link>
						<router-link to="/" class="site-logo__link"><img src="@/assets/img/logo2.png" class="site-logo_footer__2" alt="PMU"></router-link>

					</div><!-- /.site-logo -->


				</div>
				<div class="col-4 mt-4 d-block d-md-none footer-ad-menu__item">
					<div class="">
						<img src="@/assets/img/goodcause.png" alt="">
					</div>
				</div>
				<div class="col-md-8 col-sm-8 col-xs-12 site-footer__right">
					<ul class="footer-menu">
						<!-- Footer menu first level -->
						<li class="footer-menu__item" :key="'footer-item__'+item.id" v-for="item in navList">
							<nav-link :nav="item">{{ item.label}}</nav-link>
							<ul class="footer-menu__submenu" v-if="item.child">
								<!-- Footer menu second level -->
								<li class="footer-menu__subitem" :key="'footer-subitem__'+subitem.id" v-for="subitem in item.child">
									<nav-link :nav="subitem">{{ subitem.label}}</nav-link>
								</li>
							</ul>
						</li>
					</ul><!-- /.footer-menu -->
					<div class="row footer-ad-menu d-none d-md-flex">
						<div class="col-12 col-md-4 footer-ad-menu__item">
							Follow us
							<a href="https://www.facebook.com/LoterieNationaleLuxembourg/" target="_blank" class="roundedIcon">
								<img src="@/assets/img/footerfacebook.png" alt="">
							</a>
						</div>
						<div class="col-12 col-md-4 footer-ad-menu__item">
							Interdiction aux moins de
							<div class="roundedIcon">
								<img src="@/assets/img/18ans.png" alt="">
							</div>
						</div>
						<div class="col-12 col-md-4 footer-ad-menu__item">
							<div class="">
								<img src="@/assets/img/goodcause.png" alt="">
							</div>
						</div>
					</div>
					<!--<pre class="debug remove-me">SOCIAL NETWORKS</pre>-->
					<div class="btn-group" role="group" aria-label="Basic example" v-if="env.lang_bar">
						<button type="button" class="btn" @click="$store.commit('changeLang', 'en')"
								:class="{ 'btn-success': lang =='en', 'btn-secondary': lang !='en' }">EN
						</button>
						<button type="button" class="btn " @click="$store.commit('changeLang', 'fr')"
								:class="{ 'btn-success': lang =='fr', 'btn-secondary': lang !='fr' }">FR
						</button>
					</div>
				</div>
			</div>



		</div>
		<div class="copyright">
			<div class="container">
				<div class="row">
					<div class="col-8 col-md-12">
						<span v-if="env.lang_bar">v.{{version}} </span> © Loterie Nationale, tous droits réservés. {{ new Date().getFullYear() }}
					</div>
					<div class="col-4 d-flex align-items-center justify-content-end ">
						<div class="roundedIcon">
							<img src="@/assets/img/18ans.png" alt="">
						</div>
						<a href="https://www.facebook.com/LoterieNationaleLuxembourg/" target="_blank" class="roundedIcon ml-2">
							<img src="@/assets/img/footerfacebook.png" alt="">
						</a>
					</div>
				</div>
			</div>
		</div><!-- /.copyright -->
		<div class="backtotop" @click="toTop" title="Retour en haut">
		</div>
	</footer>
</template>
<script>


	import Vuex from 'vuex';
	import navLink from '@/components/parts/navLink';

	export default {
		name: 'Footer',
		components: {
			navLink
		},
		data() {
			return {
				nav: {
					list: [
						{
							id: 1,
							path: '#',
							label: 'Mentions légales',
							requireLogin: false,
							blank: true,
							childs: [
								{
									id: 2,
									path: '#',
									label: 'Qui sommes-nous?',
									requireLogin: false,
									blank: true
								},
								{
									id: 3,
									path: '#',
									label: 'Conditions générales de vente',
									requireLogin: false,
									blank: true
								}
							]
						},
						{
							id: 4,
							path: '/guide',
							label: 'GUIDE DES PARIS',
							requireLogin: false,
							blank: false,
							childs: [
								{
									id: 5,
									path: '#',
									label: 'Comment parier',
									requireLogin: false,
									blank: true
								},
								{
									id: 6,
									path: '#',
									label: 'Jouons responsable',
									requireLogin: false,
									blank: true
								}
							]
						},
						{
							id: 7,
							path: '/contact',
							label: 'CONTACT',
							requireLogin: false,
							blank: false,
							childs: [
								{
									id: 8,
									path: '/sellpoints',
									label: 'Nos agences',
									requireLogin: false,
									blank: false
								},
								{
									id: 9,
									path: 'tel:+212537271000',
									label: 'Tel. : +212 (0) 537 27 10 00',
									requireLogin: false,
									blank: true
								}
							]
						}
					]
				}
			}
		},
		computed: {
			...Vuex.mapState([
				'lang',
				'version',
				'env'
			]),
			...Vuex.mapGetters({
				getFooterNav: 'getFooterNav'
			}),
			navList() {

				if (this.getFooterNav && this.getFooterNav.length) {
					return this.getFooterNav;
				} else {
					return this.nav.list;
				}
			}
		},
		mounted() {

		},
		methods: {
			toTop() {

				// eslint-disable-next-line
				$('html, body').animate({
					scrollTop: 0
				}, 1000);
			}
		}
	}
</script>